import Marquee from "react-fast-marquee";
import {
  SiPython,
  SiPytorch,
  SiTensorflow,
  SiOpenaigym,
  SiAnthropic,
  SiGooglecloud,
  SiGooglegemini,
  SiDocker,
  SiKubernetes,
  SiFastapi,
  SiHuggingface,
  SiLangchain,
  SiMlflow,
  SiPandas,
  SiNumpy,
  SiScikitlearn,
  SiRedis,
  SiGithubactions,
  SiTerraform,
  SiGrafana,
  SiPrometheus,
  SiJupyter,
  SiOnnx,
  SiDatabricks,
} from "react-icons/si";

const LOGOS = [
  { Icon: SiPython, label: "Python" },
  { Icon: SiPytorch, label: "PyTorch" },
  { Icon: SiTensorflow, label: "TensorFlow" },
  { Icon: SiOpenaigym, label: "OpenAI" },
  { Icon: SiAnthropic, label: "Anthropic" },
  { Icon: SiGooglegemini, label: "Gemini" },
  { Icon: SiGooglecloud, label: "GCP" },
  { Icon: SiDocker, label: "Docker" },
  { Icon: SiKubernetes, label: "Kubernetes" },
  { Icon: SiFastapi, label: "FastAPI" },
  { Icon: SiHuggingface, label: "Hugging Face" },
  { Icon: SiLangchain, label: "LangChain" },
  { Icon: SiMlflow, label: "MLflow" },
  { Icon: SiPandas, label: "Pandas" },
  { Icon: SiNumpy, label: "NumPy" },
  { Icon: SiScikitlearn, label: "scikit-learn" },
  { Icon: SiJupyter, label: "Jupyter" },
  { Icon: SiRedis, label: "Redis" },
  { Icon: SiGithubactions, label: "GH Actions" },
  { Icon: SiTerraform, label: "Terraform" },
  { Icon: SiGrafana, label: "Grafana" },
  { Icon: SiPrometheus, label: "Prometheus" },
  { Icon: SiDatabricks, label: "Databricks" },
  { Icon: SiOnnx, label: "ONNX" },
];

export default function TechStack() {
  return (
    <section
      id="tech-stack"
      data-testid="tech-stack-section"
      className="bg-[#FAFAF7] border-y border-slate-200 relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12">
          <div className="md:col-span-4">
            <p className="font-mono uppercase tracking-[0.24em] text-xs text-slate-500 mb-4">
              — The Stack
            </p>
            <h3 className="font-serif text-3xl md:text-4xl tracking-tight text-slate-900">
              What you&rsquo;ll ship with.
            </h3>
          </div>
          <div className="md:col-span-6 md:col-start-6 self-end">
            <p className="text-slate-600 font-sans text-base leading-relaxed">
              Foundation models, orchestration frameworks, cloud platforms and
              observability tools — the toolkit used by teams shipping AI to
              production today.
            </p>
          </div>
        </div>
      </div>

      <Marquee
        gradient
        gradientColor="#FAFAF7"
        gradientWidth={120}
        speed={40}
        pauseOnHover
      >
        <div className="flex items-center gap-16 py-8 pr-16">
          {LOGOS.map(({ Icon, label }, i) => (
            <div
              key={`${label}-${i}`}
              className="flex flex-col items-center justify-center gap-3 text-slate-400 hover:text-slate-900 transition-colors"
              data-testid={`tech-logo-${label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <Icon size={40} />
              <span className="text-[10px] font-mono uppercase tracking-widest">
                {label}
              </span>
            </div>
          ))}
        </div>
      </Marquee>

      <div className="max-w-7xl mx-auto px-6 md:px-10 pb-20 md:pb-24 pt-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 border-t border-slate-200 pt-10 text-xs font-mono uppercase tracking-widest text-slate-500">
          <div>
            <p className="text-slate-900 mb-2 normal-case font-serif text-lg tracking-tight">Foundation models</p>
            <p>GPT · Claude · Gemini · Mistral · LLaMA · Whisper</p>
          </div>
          <div>
            <p className="text-slate-900 mb-2 normal-case font-serif text-lg tracking-tight">Agents & RAG</p>
            <p>LangGraph · CrewAI · AutoGen · LangChain · LlamaIndex</p>
          </div>
          <div>
            <p className="text-slate-900 mb-2 normal-case font-serif text-lg tracking-tight">MLOps</p>
            <p>MLflow · DVC · W&amp;B · EvidentlyAI · Arize Phoenix</p>
          </div>
          <div>
            <p className="text-slate-900 mb-2 normal-case font-serif text-lg tracking-tight">Cloud & CI/CD</p>
            <p>Vertex AI · Azure AI · AKS · GH Actions · Terraform</p>
          </div>
        </div>
      </div>
    </section>
  );
}
